import {ReactNode} from 'react'

import {LoginProvider} from './LoginProvider'
import {UserContextProvider} from './UserContextProvider'

export interface AuthProviderProps {
  children: ReactNode
}

/**
 * Convenience wrapper that combines UserContextProvider and LoginProvider
 * Use this for simple cases where you want both providers configured correctly
 *
 * @example
 * <AuthProvider>
 *   <App />
 * </AuthProvider>
 *
 * For advanced use cases, you can manually compose the providers:
 * @example
 * <UserContextProvider initialUserValue={customUser}>
 *   <LoginProvider>
 *     <App />
 *   </LoginProvider>
 * </UserContextProvider>
 */
export const AuthProvider = ({children}: AuthProviderProps) => {
  return (
    <UserContextProvider initialUserValue={null}>
      <LoginProvider>{children}</LoginProvider>
    </UserContextProvider>
  )
}
